import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-brand-water-chiller',
  templateUrl: './multi-brand-water-chiller.component.html',
  styleUrls: ['./multi-brand-water-chiller.component.scss']
})
export class MultiBrandWaterChillerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
